import { Menus, MenuTarget } from '@/entities/menus'
import HTTP from '@/plugin/http'
import { normalizeSlug, toPlainObject } from '@utils'

export async function menusList() {
  const data = await HTTP.create('about-us/menus', Menus).json(MenuTarget)
  return toPlainObject(data) as unknown as Menus[]
}

export async function getMenuBySlug(slug: string) {
  const menus = await menusList()

  return menus.find(
    (m) => normalizeSlug(String(m.slug)) === normalizeSlug(slug)
  )
}

export async function getMenuByStyle(style: string) {
  const menus = await menusList()
  return menus.find((m) => m.style === style)
}
